const it = {
  // Header / Navigation
  'nav.sports': 'Scommesse Sportive',
  'nav.live': 'Scommesse Live',
  'nav.games': 'Giochi',
  'nav.promotions': 'Promozioni',
  'nav.deposit': 'Deposito',
  'nav.myBets': 'Le mie scommesse',
  'nav.news': 'Notizie',
  'nav.account': 'Conto',
  'nav.login': 'Accedi',
  'nav.register': 'Registrati',
  'nav.logout': 'Esci',

  // Sidebar
  'sidebar.search': 'Squadra, Evento o Competizione',
  'sidebar.quickAccess': 'Accesso Rapido',
  'sidebar.topEvents': 'Eventi Principali',
  'sidebar.topKombis': 'Top Multiple',
  'sidebar.todayMatches': 'Partite di Oggi',
  'sidebar.germanFootball': 'Calcio Tedesco',
  'sidebar.europeanFootball': 'Calcio Europeo',
  'sidebar.topCompetitions': 'Competizioni Top',
  'sidebar.topSports': 'Sport Principali',
  'sidebar.allSports': 'Tutti gli Sport',
  'sidebar.showAllCategories': 'Mostra tutte le categorie',
  'sidebar.hideCategories': 'Nascondi categorie',

  // Sports
  'sport.football': 'Calcio',
  'sport.tennis': 'Tennis',
  'sport.basketball': 'Pallacanestro',
  'sport.iceHockey': 'Hockey su Ghiaccio',
  'sport.handball': 'Pallamano',
  'sport.baseball': 'Baseball',
  'sport.americanFootball': 'Football Americano',
  'sport.boxing': 'Pugilato',
  'sport.cricket': 'Cricket',
  'sport.darts': 'Freccette',
  'sport.rugby': 'Rugby',
  'sport.tableTennis': 'Tennistavolo',
  'sport.beachVolleyball': 'Beach Volley',
  'sport.esports': 'E-Sports',

  // Market Types
  'market.tip': 'Esito',
  'market.tipRemainingTime': 'Tempo Rimanente',
  'market.firstHalf': '1° Tempo',
  'market.overUnder': 'Over/Under',
  'market.doubleChance': 'Doppia Chance',
  'market.bothTeamsScore': 'Entrambe le squadre segnano',

  // Bet Outcomes
  'outcome.fhHomeWinRemainingTime': '1T Vittoria Casa Rim.',
  'outcome.fhDrawRemainingTime': '1T Pareggio Rim.',
  'outcome.fhAwayWinRemainingTime': '1T Vittoria Trasf. Rim.',
  'outcome.fhNextGoalHome': '1T Prossimo Gol Casa',
  'outcome.fhNextGoalAway': '1T Prossimo Gol Trasf.',
  'outcome.nextGoalHome': 'Prossimo Gol Casa',
  'outcome.nextGoalAway': 'Prossimo Gol Trasf.',
  'market.nextGoal': 'Prossimo Gol',
  'outcome.home': 'Casa',
  'outcome.away': 'Trasferta',
  'outcome.homeWin': 'Vittoria Casa',
  'outcome.draw': 'Pareggio',
  'outcome.awayWin': 'Vittoria Trasferta',
  'outcome.over': 'Over',
  'outcome.under': 'Under',
  'outcome.yes': 'Sì',
  'outcome.no': 'No',
  'outcome.fhHomeWin': '1T Vittoria Casa',
  'outcome.fhDraw': '1T Pareggio',
  'outcome.fhAwayWin': '1T Vittoria Trasf.',
  'outcome.fhOver': '1T Over',
  'outcome.fhUnder': '1T Under',
  'outcome.homeWinRemainingTime': 'Vittoria Casa (Rim.)',
  'outcome.drawRemainingTime': 'Pareggio (Rim.)',
  'outcome.awayWinRemainingTime': 'Vittoria Trasf. (Rim.)',

  // Section Titles
  'section.nextGames': 'Prossime Partite',
  'section.topEvents': 'Eventi Principali',
  'section.lastMinute': 'Ultimo Minuto',
  'section.live': 'Live',
  'section.next6Hours': 'Prossime 6 Ore',
  'section.topKombis': 'Top Multiple',
  'section.topKombisSubtitle': 'da altri clienti',
  'section.showAll': 'Mostra tutto',
  'section.viewAll': 'Tutto',

  // Betting Slip
  'slip.title': 'Schedina',
  'slip.empty': 'La tua schedina è vuota.',
  'slip.emptyHint': 'Seleziona le tue scommesse ora.',
  'slip.single': 'Singola',
  'slip.combi': 'Multipla',
  'slip.system': 'Sistema',
  'slip.stake': 'Puntata',
  'slip.totalStake': 'Puntata Totale',
  'slip.setStake': 'Imposta Puntata',
  'slip.totalOdds': 'Quota Totale',
  'slip.potentialWin': 'Vincita Potenziale',
  'slip.placeBet': 'Piazza Scommessa',
  'slip.openBets': 'Scommesse Aperte',
  'slip.viewTicket': 'Visualizza Ticket',
  'slip.noOpenBets': 'Non hai scommesse aperte.',
  'slip.combiBet': 'Scommessa Multipla',
  'slip.singleBet': 'Scommessa Singola',
  'slip.singleBets': 'Scommesse Singole',
  'slip.potentialWinShort': 'Vincita Pot.',
  'slip.maxWin': 'Vincita Max.',
  'slip.requestCashout': 'Richiedi Cashout',
  'slip.combinations': 'Combinazioni (Linee)',
  'slip.cashoutValue': 'Valore Cashout',
  'slip.confirmCashout': 'Conferma Cashout',
  'slip.errorRequestingQuote': 'Errore durante la richiesta di quota.',
  'slip.cashoutFailed': 'Cashout fallito.',
  'slip.error.payoutLimitExceeded': 'Limite massimo di vincita superato. Per favore riduci la puntata.',
  'slip.errorPlacingBet': 'Errore durante la piazzamento scommessa.',
  'slip.placementScore': 'Piazzamento :',
  'slip.currentScore': 'Attuale :',
  'slip.placingBet': 'Creazione ticket...',
  'slip.placingWait': 'Attendere prego...',
  'slip.placingBtn': 'Piazzamento...',
  'slip.betSuccess': 'Ticket Approvato',
  'slip.betSuccessDesc': 'La tua scommessa è stata piazzata con successo!',
  'slip.hasLockedBets': 'La tua schedina contiene scommesse bloccate/sospese.',

  // Live
  'live.noEvents': 'Nessun evento live per',
  'live.games': 'Partite',
  'live.sortBy': 'Ordina per :',
  'live.time': 'Ora',
  'live.competition': 'Competizione',
  'live.halfTime': '1° Tempo',
  'live.ht': 'PT',
  'live.ft': 'FT',

  // Time
  'time.today': 'Oggi',
  'time.tomorrow': 'Domani',
  'time.minutes': 'Min',
  'time.hoursShort': 'Ore',

  // Top Kombis Card
  'kombis.betsPlaced': 'Scommesse piazzate',
  'kombis.combi': 'Multipla',
  'kombis.totalOdds': 'Quota Totale',
  'login.failed': 'Accesso non riuscito',
  'login.invalidCredentials': 'Credenziali non valide',

  // Account
  'account.myAccount': 'Il mio Conto',
  'account.loginPrompt': 'Effettua il login per gestire il tuo conto.',
  'account.verification': 'Verifica Conto',
  'account.management': 'Gestione Conto e Limiti',
  'account.transactions': 'Transazioni',
  'account.personalData': 'Dati Personali',
  'account.responsibleGaming': 'Gioco Responsabile',
  'account.meineDaten': 'I miei Dati',
  'account.kontoverifizierung': 'Verifica Conto',
  'account.kontoverwaltung': 'Gestione e Limiti',
  'account.transaktionsverlauf': 'Cronologia Transazioni',
  'account.guthaben': 'Saldo',
  'account.auszahlung': 'Prelievo',
  'account.einstellungen': 'Impostazioni',
  'account.neuigkeiten': 'Notizie',
  'account.apps': 'App Tipico',
  'account.kontakt': 'Contatti',
  'account.abmelden': 'Esci e Disattiva',
  'account.userTabs.personal': 'Dati Utente',
  'account.userTabs.contact': 'Dettagli Contatto',
  'account.userTabs.password': 'Cambia Password',
  'account.fields.name': 'Nome e Cognome :',
  'account.fields.username': 'Nome Utente :',
  'account.fields.birthname': 'Nome di Nascita :',
  'account.fields.birthdate': 'Data di Nascita :',
  'account.fields.email': 'Email :',
  'account.fields.emailChange': 'Cambia Email',
  'account.fields.lugasId': 'ID Giocatore Lugas :',
  'account.underConstruction': 'Questa sezione è ancora in costruzione.',
  'account.supportPlaceholder': 'Descrivi la tua richiesta nel modo più accurato possibile...',
  'account.salutationMr': 'Sig.',
  'account.loginBtn': 'Accedi',
  'account.transactions.title': 'Cronologia Transazioni',
  'account.transactions.type': 'Tipo',
  'account.transactions.amount': 'Importo',
  'account.transactions.status': 'Stato',
  'account.transactions.date': 'Data',
  'account.transactions.id': 'ID Riferimento',
  'account.transactions.noTransactions': 'Nessuna transazione trovata.',
  'account.transactions.deposit': 'Deposito',
  'account.transactions.withdrawal': 'Prelievo',
  'account.transactions.status.completed': 'Riuscito',
  'account.transactions.status.pending': 'In attesa',
  'account.transactions.status.failed': 'Fallito',
  'account.transactions.filter.all': 'Tutti',
  'account.transactions.filter.startDate': 'Dal :',
  'account.transactions.filter.endDate': 'Al :',
  'account.transactions.filter.reset': 'Ripristina',
  'account.balance.title': 'Saldo e Portafoglio',
  'account.balance.total': 'Saldo Totale',
  'account.balance.available': 'Disponibile',
  'account.balance.locked': 'Bloccato',
  'account.balance.realCash': 'Denaro Reale',
  'account.balance.bonusCash': 'Saldo Bonus',
  'account.balance.premiumWallet': 'Portafoglio Premium',
  'account.balance.depositAction': 'Deposita Fondi',
  'account.balance.withdrawAction': 'Preleva Fondi',
  'account.balance.recentActivity': 'Attività Recenti',
  'account.balance.viewAllTransactions': 'Vedi tutte le transazioni',
  'account.notifications.title': 'Notizie e Notifiche',
  'account.notifications.empty': 'Nessuna notifica disponibile.',
  'account.notifications.markAllRead': 'Segna tutte come lette',
  'account.notifications.markRead': 'Segna come letta',
  'account.notifications.viewAll': 'Mostra tutto',
  'account.withdrawal.title': 'Avvia Prelievo',
  'account.withdrawal.selectMethod': 'Seleziona metodo :',
  'account.withdrawal.amount': 'Importo Prelievo',
  'account.withdrawal.enterAmount': 'Inserisci importo',
  'account.withdrawal.availableToWithdraw': 'Saldo prelevabile :',
  'account.withdrawal.submit': 'Richiedi Prelievo',
  'account.withdrawal.processingTime': 'Durata',
  'account.withdrawal.instant': 'Istantaneo',
  'account.withdrawal.bankDays': '1-3 giorni lavorativi',
  'account.withdrawal.successMessage': 'La tua richiesta è stata inoltrata con successo!',
  'account.withdrawal.successSub': 'L\'importo sarà accreditato sul tuo metodo di pagamento a breve.',
  'account.withdrawal.refId': 'ID Riferimento :',
  'account.withdrawal.error.insufficient': 'Saldo insufficiente.',
  'account.withdrawal.error.minimum': 'L\'importo minimo per il prelievo è 10 €.',
  'account.withdrawal.backToWallet': 'Torna al Saldo',

  // Login/Register
  'auth.loginTitle': 'Accedi',
  'auth.registerTitle': 'Registrati',
  'auth.email': 'Email',
  'auth.username': 'Nome utente',
  'auth.password': 'Password',
  'auth.confirmPassword': 'Conferma password',
  'auth.noAccount': 'Non hai ancora un conto?',
  'auth.hasAccount': 'Hai già un conto?',
  'auth.welcomeTitle': 'Tuffati nel mondo delle scommesse!',
  'auth.bonusTitle': 'Raddoppia il tuo primo deposito',
  'auth.bonusSubtitle': 'fino a 100 €',
  'auth.registrationOnlyGermany': 'La registrazione è disponibile solo dalla Germania.',

  // My Bets
  'bets.myBets': 'Le mie Scommesse',
  'bets.active': 'Attive',
  'bets.settled': 'Concluse',
  'bets.won': 'Vinte',
  'bets.lost': 'Perse',
  'bets.pending': 'In sospeso',

  // Misc
  'match.mainBets': 'Scommesse Principali',
  'match.allBets': 'Tutte le Scommesse',
  'misc.noOdds': 'Nessuna quota',
  'misc.matches': 'Partite',
  'misc.matchKombi': 'MatchCombo+',
  'misc.outrights': 'Antepost',
  'misc.statistics': 'Statistiche',
  'misc.search': 'Cerca',
  'misc.close': 'Chiudi',
  'misc.back': 'Indietro',
  'misc.events': 'Eventi',
  'misc.topCompetitions': 'Competizioni Top',
  'misc.noMatches': 'Nessuna partita da mostrare.',
  'misc.loading': 'Caricamento…',
  'misc.confirmColon': 'Conferma :',
  'misc.confirm': 'Conferma',
  'misc.cancel': 'Annulla',
  'misc.error': 'Errore.',
};

export default it;
